import { Components, Theme } from '@mui/material/styles';

export const muiAccordionSummaryOverride: Components<Theme>['MuiAccordionSummary'] = {
  styleOverrides: {
    root: {
      padding: 0,
      '&.Mui-expanded': {
        margin: 0,
      },
    },
    content: ({ theme }) => ({
      margin: theme.spacing(7.75, 0),
    }),
    expandIconWrapper: ({ theme }) => ({
      color: theme.palette.primary.main,
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      '&.Mui-expanded': {
        transform: 'rotate(180deg)',
      },
    }),
  },
};
